import React, { FC } from 'react'
import styles from './LayoutsSidebar.module.scss'
import { ScreenGroup } from '../../Screen'
import WebcamScreen from '../../WebcamScreen'
import LayoutsSelectPresenter from '../LayoutsSelectPresenter'
import { LayoutsSidebarProps } from './types'
import { mediaType as MediaType } from '@bt-react/constants'

const LayoutsSidebar: FC<LayoutsSidebarProps> = ({ isSplitView = false, autoSpotlight,
  focusedPresenter, presenters, mediaType, maxPresenters, isBridgeInstance = false }) => (
  <div className={styles['layout-sidebar-container']}>
    <ScreenGroup layout='list'>
      {
        isSplitView ?
          presenters.map((presenterData) => focusedPresenter?.BTID !== presenterData.BTID ? undefined :
            <WebcamScreen
              key={`layout-webcam-item-${presenterData.BTID}`}
              presenter={presenterData}
              size='sm'
              inSidebar={true} />
          ).slice(0, maxPresenters) :
          presenters.map((presenterData) => mediaType === MediaType.SPOTLIGHT && focusedPresenter?.BTID === presenterData.BTID ? undefined :
            <WebcamScreen
              key={`layout-webcam-item-${presenterData.BTID}`}
              presenter={presenterData}
              size='sm'
              inSidebar={true} />
          ).slice(0, maxPresenters)
      }
    </ScreenGroup>
    {
      isSplitView && !isBridgeInstance && presenters.length >= 1 &&
      <LayoutsSelectPresenter
        presenters={presenters}
        autoSpotlight={autoSpotlight}
        focusedPresenterID={focusedPresenter?.BTID}
      />
    }
  </div>
)

export default LayoutsSidebar